import { motion, AnimatePresence } from 'framer-motion';

const WAVE_WIDTH = 280;
const WAVE_HEIGHT = 40;

function generatePath(width, height, amplitude, frequency, phase = 0) {
    const mid = height / 2;
    const pts = [];
    const total = width * 2;
    for (let x = 0; x <= total; x += 2) {
        const y = mid + Math.sin((x / total) * Math.PI * 2 * frequency + phase) * amplitude;
        pts.push(`${x === 0 ? 'M' : 'L'} ${x} ${y.toFixed(1)}`);
    }
    return pts.join(' ');
}

const waves = [
    { amp: 10, freq: 2, phase: 0,   color: 'rgba(168, 144, 96, 0.75)', width: 2,   duration: 4.2 },
    { amp: 7,  freq: 3, phase: 1.1, color: 'rgba(200, 165, 120, 0.55)', width: 1.6, duration: 3 },
    { amp: 5,  freq: 4, phase: 2.4, color: 'rgba(228, 204, 165, 0.45)', width: 1.3, duration: 2.2 },
];

/**
 * ThinkingWave — 3-layer sine wave，AI 思考中時顯示在 orb 下方。
 * 暖色調（accent amber tan），跟 admin-console 風格一致。
 */
export default function ThinkingWave({ isActive = false }) {
    return (
        <AnimatePresence>
            {isActive && (
                <motion.div
                    key="thinking-wave"
                    initial={{ opacity: 0, scaleY: 0 }}
                    animate={{ opacity: 1, scaleY: 1 }}
                    exit={{ opacity: 0, scaleY: 0 }}
                    transition={{ duration: 0.35, ease: 'easeOut' }}
                    style={{
                        position: 'relative',
                        width: `${WAVE_WIDTH}px`,
                        height: `${WAVE_HEIGHT}px`,
                        margin: '0 auto',
                        pointerEvents: 'none',
                        overflow: 'hidden',
                        filter: 'drop-shadow(0 0 6px rgba(168,144,96,0.4))',
                    }}
                >
                    {waves.map((w, i) => (
                        <svg
                            key={i}
                            viewBox={`0 0 ${WAVE_WIDTH * 2} ${WAVE_HEIGHT}`}
                            preserveAspectRatio="none"
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: `${WAVE_WIDTH * 2}px`,
                                height: '100%',
                                animation: `tw-scroll-${i} ${w.duration}s linear infinite`,
                            }}
                        >
                            <path
                                d={generatePath(WAVE_WIDTH, WAVE_HEIGHT, w.amp, w.freq, w.phase)}
                                fill="none"
                                stroke={w.color}
                                strokeWidth={w.width}
                                strokeLinecap="round"
                            />
                        </svg>
                    ))}

                    <style>{`
                        @keyframes tw-scroll-0 { from { transform: translateX(0); } to { transform: translateX(-${WAVE_WIDTH}px); } }
                        @keyframes tw-scroll-1 { from { transform: translateX(0); } to { transform: translateX(-${WAVE_WIDTH}px); } }
                        @keyframes tw-scroll-2 { from { transform: translateX(0); } to { transform: translateX(-${WAVE_WIDTH}px); } }
                    `}</style>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
